import { FormForwardUserStatus, ManagementFormLogType, FormForwardType } from '@business/entities/managementForms';
import { UpdateFormForwardStatusModalProps } from '@modules/Forms/UpdateFormForwardStatusModal/UpdateFormForwardStatusModal';

export function getStatusTitle(status: FormForwardUserStatus) {
  switch (status) {
    case FormForwardUserStatus.pending:
      return 'Pending';
    case FormForwardUserStatus.approved:
      return 'Approved';
    case FormForwardUserStatus.rejected:
      return 'Rejected';
    case FormForwardUserStatus.draft:
      return 'Draft';
  }
}

export function getStatusClass(status: FormForwardUserStatus) {
  switch (status) {
    case FormForwardUserStatus.pending:
      return 'badge-soft-info';
    case FormForwardUserStatus.approved:
      return 'badge-soft-primary';

    case FormForwardUserStatus.rejected:
      return 'badge-soft-danger';
    case FormForwardUserStatus.draft:
      return 'badge-soft-warning';
  }
}

export function getLogColor(type: ManagementFormLogType) {
  switch (type) {
    case ManagementFormLogType.approved:
      return 'success';
    case ManagementFormLogType.rejected:
      return 'danger';

    case ManagementFormLogType.forwarded:
      return 'info';
    case ManagementFormLogType.created:
      return 'info';
    case ManagementFormLogType.updated:
      return 'info';
  }
}

export function getFormForwardTypeTitle(type: FormForwardType) {
  switch (type) {
    case FormForwardType.approval:
      return 'Send Request for Approval';
    case FormForwardType.send:
      return 'Send';
  }
}

export function allFormForwardTypes() {
  return [FormForwardType.approval, FormForwardType.send];
}

export function getFormForwardTypeItems() {
  return allFormForwardTypes().map(type => ({
    label: getFormForwardTypeTitle(type),
    value: type,
  }));
}

export function isSame(current: any, saved: any) {
  let same = true;
  Object.keys(current).forEach(key => {
    if (current[key] !== saved[key]) {
      same = false;
    }
  });
  return same;
}
